export default __webpack_public_path__ + "static/media/app-logo-white.df6f5d72.png";